$(document).on('click', '.trending-search p', function () {
  const text = $(this).text().trim();
  const $input = $('#side-panel-search-input');
  $input
    .val(text)
    .focus()
    .trigger('input'); 
});

const observer = new MutationObserver(() => {
  const srLink = document.querySelector('a.acsb-sr-only');
  if (srLink) {
    const target = document.querySelector('header') || document.querySelector('[role="banner"]');
    if (target) {
      target.prepend(srLink);
      observer.disconnect(); 
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });


// PDP — Scroll To Product Section

    const productSection = document.querySelector('.shopify-section.product-section');
    if (productSection) {
      requestAnimationFrame(() => {
        const yOffset = -60; 
        const element = productSection;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }
